import styled from "styled-components";

export const RelatorioContainer = styled.section`
    padding: 50px 0;
    background: #f8f8f9;
    height: auto;
    padding-bottom: 250px;
    scroll-behavior: smooth;
`;
